// extracted by mini-css-extract-plugin
export default {"iconWrap":"iconWrap-JrDRFx","lineWrap":"lineWrap-klJGpj","line":"line-jSJLCW","or":"or-pt1kA3","iconWrapH5":"iconWrapH5-HMj8xk","normalButton":"normalButton-KP2Frd"};